import React, { Component } from 'react';
import { Table, Tooltip, Icon, message, Popover } from 'antd';
import cf from '../../../../utils/cf';
import fp from '../../../../utils/fp';
import API_URL from '../../../../common/url';
import Fetch from '../../../../common/Fetch';
import format from '../../../shared/format';
import isEmptyObject from '../../../shared/isEmptyObject';
import { calcDisplayColumns } from '../common';
import renderEnhancer from '../../../shared/renderEnhancer';
import cellRenderEnhancer, { beforeChangeEnhancer } from '../../../shared/cellRenderEnhancer';

class ContractTable extends Component {
    constructor(props) {
        super(props);
        const { data: { openStatus } = {} } = props;
        this.state = {
            loading: false,
            expanded: openStatus == 1,
        };
    }

    handleClick = () => {
        const { data: { investigationJdeContractId } = {} } = this.props;
        const { expanded } = this.state;
        this.setState({ loading: true });
        Fetch.post(API_URL.contract.saveUserListOpen, {
            relatedId: investigationJdeContractId,
            openStatus: expanded ? 0 : 1,
            type: 'APPLICATION_CONTRACT'
        }).then(res => {
            message.success(res.success);
            this.setState({
                loading: false,
                expanded: !expanded,
            });
        });
    }

    getColumns = () => {
        const { expanded } = this.state;
        const columns = [{
            title: (
                <span>
                    JDE项目号
                    <Icon
                        type={`${expanded ? 'minus' : 'plus'}-square-o`}
                        style={{
                            cursor: 'pointer',
                            position: 'relative',
                            top: '2px',
                            marginLeft: '10px',
                        }}
                        onClick={this.handleClick}
                    />
                </span>
            ),
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            render: (text, record) => {
                return <span>{text}<Icon type="paper-clip" style={{color: '#ffbf00', cursor: 'pointer'}} onClick={() => this.props.showAttachment(record, 'contract')}/></span>;
            },
        }, {
            title: '合同性质',
            dataIndex: 'contractNatureShow',
            key: 'contractNatureShow',
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineNames',
            key: 'secondLineNames',
        }, {
            title: '计收入确认方式',
            dataIndex: 'contractTypeValue',
            key: 'contractTypeValue',
            render: cellRenderEnhancer({
                renderContent: beforeChangeEnhancer((record) => record['oldContractTypeValue'])
           })(),
        }, {
            title: '医院名称或数量',
            dataIndex: 'hospitalNameAndAmount',
            key: 'hospitalNameAndAmount',
            width: 120,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {hospitalNameAndAmount } = record;
                        const hospitalNameAndAmountList = hospitalNameAndAmount?hospitalNameAndAmount.split(';'):[]
                        if ((hospitalNameAndAmountList || []).length > 1) {
                            return (
                                <div>
                                    {
                                        hospitalNameAndAmountList.map((value,index) => (
                                            <div key={index}>
                                                {value} 
                                            </div>
                                        ))
                                    }
                                </div>
                            );
                        }
                    }
                })(text => text ? <span style={{color: '#F00'}}>{text.split(';')[0]}</span> : '')
            ),
        }, {
            title: '请款联系人信息',
            dataIndex: 'remittanceUser',
            key: 'remittanceUser',
            render: text => text ? <span style={{color: '#F00'}}>{text}</span> : '',
        }, {
            title: '合同总金额/人民币(元)',
            dataIndex: 'jdeContractAmount',
            key: 'jdeContractAmount',
            render: text => format('money', text),
        }, {
            title: '已开票总金额/人民币(元)',
            dataIndex: 'grossAmount',
            key: 'grossAmount',
            render: text => format('money', text),
        }, {
            title: '已回款总金额/人民币(元)',
            dataIndex: 'receivingAmount',
            key: 'receivingAmount',
            render: text => format('money', text),
        }, {
            title: 'PM确认已到Milestone但未请款金额/人民币(元)',
            dataIndex: 'notApplyAmount',
            key: 'notApplyAmount',
            render: text => format('money', text),
        }, {
            title: '合同请款完成情况',
            dataIndex: 'remittanceCompletedInfoShow',
            key: 'remittanceCompletedInfoShow',
        }, {
            title: '发票邮寄信息',
            dataIndex: 'remittanceAddress',
            key: 'remittanceAddress',
            render: text => text ? <span style={{color: '#F00'}}>{text}</span> : '',
        }, {
            title: '请款特殊说明',
            dataIndex: 'specialComments',
            key: 'specialComments',
            render: text => text ? <span style={{color: '#F00'}}>{text}</span> : '',
        }, {
            title: '发票类型',
            dataIndex: 'invoiceType',
            key: 'invoiceType',
            render: text => text ? <span style={{color: '#F00'}}>{text}</span> : '',
        }, {
            title: '汇率',
            dataIndex: 'exchangeRate',
            key: 'exchangeRate',
        }, {
            title: '币种',
            dataIndex: 'currencyName',
            key: 'currencyName',
        }, {
            title: '合同总金额/原币',
            dataIndex: 'initialContractAmount',
            key: 'initialContractAmount',
            render: (text) => format('money', text),
        }, {
            title: '负值合同金额/人民币(元)',
            dataIndex: 'negativeAmount',
            key: 'negativeAmount',
            render: (text) => format('money', text),
        }, {
            title: (
                <span>
                    合同实际可请款金额/人民币(元)
                    <Tooltip overlayStyle={{ width: 250 }} placement="top" title={'合同额含税/人民币+负值合同金额/人民币'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'canApplyAmount',
            key: 'canApplyAmount',
            render: (text) => format('money', text),
        }, {
            title: '合同开始时间',
            dataIndex: 'contractStartTime',
            key: 'contractStartTime',
            render: text => format('date', text),
        }, {
            title: '合同结束时间',
            dataIndex: 'contractEndTime',
            key: 'contractEndTime',
            render: text => format('date', text),
        }, {
            title: '收入归属单位名称',
            dataIndex: 'belongingToUnit',
            key: 'belongingToUnit',
        }, {
            title: '服务费金额/原币',
            dataIndex: 'serviceAmount',
            key: 'serviceAmount',
            render: (text) => format('money', text),
        }, {
            title: 'PT费金额/原币',
            dataIndex: 'ptAmount',
            key: 'ptAmount',
            render: (text) => format('money', text),
        }
        ];
        
        return calcDisplayColumns(columns, this.props.heads.CASH_REQ_MULTI_CONTRACT, expanded);
    }

    getNestedColumns = () => {
        const columns = [{
            title: '请款单号',
            dataIndex: 'remittanceCode',
            key: 'remittanceCode',
            fixed: 'left',
            width: 120,
            render: renderEnhancer((text, record) => {
                if (text === '合计') {
                    return <strong>{text}</strong>
                }
                const { fileList } = record;
                return <span>{text}{ !!(fileList || []).length && <Icon type="paper-clip" style={{color: '#ffbf00', cursor: 'pointer'}} onClick={() => this.props.showAttachment(record, 'request')}/> }</span>;
            }),
        }, {
            title: '客户付款单位',
            dataIndex: 'customerCompany',
            key: 'customerCompany',
            width: 120,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: beforeChangeEnhancer(
                        (record) =>
                            format('joint', record['oldCustomerCompanyName'], record['oldCustomerCompanyCode'], 'roundBrackets')
                    )
                })()
            ),
        }, 
        {
            title: '客户CSA',
            dataIndex: 'csaNameCode',
            key: 'csaNameCode',
            width: 100,
            render: renderEnhancer(),
        }, {
            title: 'milestone到达日期',
            dataIndex: 'cashReqNodeDateShow',
            key: 'cashReqNodeDateShow',
            width: 100,
            render: renderEnhancer(),
        }, {
            title: 'PM是否通知请款',
            dataIndex: 'noticeBaShow',
            key: 'noticeBaShow',
            width: 80,
            render: renderEnhancer(),
        }, {
            title: '通知请款日期',
            dataIndex: 'noticeBaDateStr',
            key: 'noticeBaDateStr',
            width: 100,
            render: renderEnhancer(),
        }, {
            title: 'PM通知备注',
            dataIndex: 'noticeBaRemark',
            key: 'noticeBaRemark',
            width: 100,
            render: renderEnhancer(),
        },{
            title: '确认可请款日期',
            dataIndex: 'baConfirmCashReqDate',
            key: 'baConfirmCashReqDate',
            width: 100,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: (record) => record.baConfirmCashReqDateTip
                })()
            ),
        }, {
            title: '请款进度',
            dataIndex: 'paymentProgress',
            key: 'paymentProgress',
            render: renderEnhancer(),
            width: 120,
        }, {
            title: '是否正负核销',
            dataIndex: 'isVerificationShow',
            key: 'isVerificationShow',
            width: 120,
            render: renderEnhancer(),
        }, {
            title: '是否请款疑难',
            dataIndex: 'isPaymentDifficultShow',
            key: 'isPaymentDifficultShow',
            width: 120,
            render: renderEnhancer(),
        }, {
            title: '请款卡脖子节点',
            dataIndex: 'paymentStopBreathingCode',
            key: 'paymentStopBreathingCode',
            width: 120,
            render: renderEnhancer(),
        }, {
            title: '请款卡脖子原因',
            dataIndex: 'paymentStopBreathingReason',
            key: 'paymentStopBreathingReason',
            width: 120,
            render: renderEnhancer(),
        }, {
            title: '更新请款进度日期',
            dataIndex: 'paymentDateShow',
            key: 'paymentDateShow',
            width: 120,
            render: renderEnhancer(),
        }, {
            title: '请款笔数',
            dataIndex: 'remittanceNum',
            key: 'remittanceNum',
            width: 80,
            render: renderEnhancer(),
        }, {
            title: '请款节点',
            dataIndex: 'cashReqNode',
            key: 'cashReqNode',
            width: 80,
            render: renderEnhancer((text, record) => {
                const { cashReqNodeType, cashReqNodeNum } = record;
                return text ? `${text}${cashReqNodeType ? cashReqNodeType === 'NNF' ? `(${cashReqNodeNum}例)` : `(合同开始后${cashReqNodeNum}天)` : ''}` : '';
            }),
        }, {
            title: '是否预收款',
            dataIndex: 'isAdvanceCollectionShow',
            key: 'isAdvanceCollectionShow',
            width: 80,
            render: renderEnhancer(),
        }, {
            title: '合同约定请款金额/原币',
            dataIndex: 'initialContractAmount',
            key: 'initialContractAmount',
            width: 100,
            render: renderEnhancer((text, record) => {
                text = format('money', text);
                if (record.remittanceCode === '合计') {
                    return <strong>{text}</strong>
                }
                return text;
            }),
        }, {
            title: '合同约定请款金额/人民币(元)',
            dataIndex: 'remittanceAmount',
            key: 'remittanceAmount',
            width: 120,
            render: renderEnhancer((text, record) => {
                text = format('money', text);
                if (record.remittanceCode === '合计') {
                    return <strong>{text}</strong>
                }
                return text;
            }),
        }, {
            title: '请款进度具体描述',
            dataIndex: 'paymentProgressComment',
            key: 'paymentProgressComment',
            width: 140,
            render: renderEnhancer(),
        }, {
            title: '发票备注要求',
            dataIndex: 'invoiceTypeComment',
            key: 'invoiceTypeComment',
            width: 120,
            render: renderEnhancer(),
        }, {
            title: '回款进度',
            dataIndex: 'progressValueShow',
            key: 'progressValueShow',
            render: renderEnhancer(),
            width: 120,
        }, {
            title: '预计回款月份',
            dataIndex: 'expectedBackMonth',
            key: 'expectedBackMonth',
            width: 120,
            render: renderEnhancer(),
        }, {
            title: '是否回款疑难',
            dataIndex: 'isReceivingDifficultShow',
            key: 'isReceivingDifficultShow',
            width: 120,
            render: renderEnhancer(),
        }, {
            title: '回款卡脖子节点',
            dataIndex: 'receivingStopBreathingCode',
            key: 'receivingStopBreathingCode',
            width: 120,
            render: renderEnhancer(),
        }, {
            title: '更新回款进度日期',
            dataIndex: 'receivingDateShow',
            key: 'receivingDateShow',
            width: 120,
            render: renderEnhancer(),
        }, {
            title: '回款进度具体描述',
            dataIndex: 'receivingStopBreathingReason',
            key: 'receivingStopBreathingReason',
            render: renderEnhancer(),
            width: 140,
        }, {
            title: '合同约定请款比例',
            dataIndex: 'cashReqRateShow',
            key: 'cashReqRateShow',
            width: 120,
            render: renderEnhancer(),
        }, {
            title: '费用类型',
            dataIndex: 'expenseType',
            key: 'expenseType',
            width: 80,
            render: renderEnhancer(),
        }, {
            title: '请款记录状态',
            dataIndex: 'statusShow',
            key: 'statusShow',
            width: 120,
            render: renderEnhancer(),
        }, {
            title: '请款调整状态',
            dataIndex: 'changeStatusShow',
            key: 'changeStatusShow',
            width: 120,
            render: renderEnhancer(),
        }, {
            title: '请款申请系统时间',
            dataIndex: 'createDate',
            key: 'createDate',
            width: 80,
            render: renderEnhancer(),
        }, {
            title: '发票日期',
            dataIndex: 'invoiceDate',
            key: 'invoiceDate',
            width: 80,
        }, {
            title: '发票号',
            dataIndex: 'remark',
            key: 'remark',
            width: 100,
        }, {
            title: '发票金额(不含税)',
            dataIndex: 'taxableAmount',
            key: 'taxableAmount',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '发票金额(税)',
            dataIndex: 'tax',
            key: 'tax',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '发票金额(含税总额)总金额',
            dataIndex: 'grossAmount',
            key: 'grossAmount',
            width: 100,
            render: (text, record) => {
                text = format('money', text);
                if (record.remittanceCode === '合计') {
                    return <strong>{text}</strong>
                }
                return text;
            },
        }, {
            title: '结算币种',
            dataIndex: 'currencyCode',
            key: 'currencyCode',
            width: 80,
        }, {
            title: '到期日期',
            dataIndex: 'dueDate',
            key: 'dueDate',
            width: 80,
        }, {
            title: '账龄',
            dataIndex: 'aging',
            key: 'aging',
            width: 80,
        }, {
            title: '合同约定账期',
            dataIndex: 'actualPaymentTerms',
            key: 'actualPaymentTerms',
            width: 80,
            render: (text,record) => {
                return text = text == null ? record.contractAgreedPaymentTerms : text
            }
        }, {
            title: (
                <span>
                    超账龄
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'超账龄 = 系统日期（收款日期）- 到期日期'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'overAging',
            key: 'overAging',
            width: 100,
        }, {
            title: '确认收款金额',
            dataIndex: 'receivingAmount',
            key: 'receivingAmount',
            width: 100,
            render: (text, record) => {
                const { dataType, gloffSet } = record;
                if ( dataType === 'FOREIGN_CURRENCY_IMPORT' || dataType === 'ADVANCE_IMPORT' ) {
                    return (
                        <Popover placement="right" overlayClassName="gray-pop" content={gloffSet || '汇率差异'}>
                            <div>
                                <i className='pop' style={{cursor: 'pointer'}}></i>
                                {format('money', text)}
                            </div>
                        </Popover>
                    )
                } else if (record.remittanceCode === '合计') {
                    return <strong>{text}</strong>
                }else{
                    return format('money', text);
                }
            },
        }, {
            title: '收款日期',
            dataIndex: 'dateInvoiceClosed',
            key: 'dateInvoiceClosed',
            width: 80,
        }];

        const { isAdd, approval, checkProjectIsFinish } = this.props;
        const { curRole, invState, userId, curEmployeeCode } = sessionStorage;
        const isPM = curRole === 'PM';
        const isBA = curRole === 'BA';
        const isBAL = curRole === 'BAL';
        const isExtraItem = invState == 0;
        const { BAL_DEFAULT_APPROVER, REMITTANCE_CUSTOMER_APPLY_USER } = approval;
        const approveAdjust = (BAL_DEFAULT_APPROVER || []).some(i => i == curEmployeeCode);
        const approvePayUnit = (REMITTANCE_CUSTOMER_APPLY_USER || []).some(i => i == curEmployeeCode);
      
        const result = calcDisplayColumns(columns, this.props.heads.CASH_REQ_MULTI_APPLICATION);

        result.push({
            title: '操作',
            dataIndex: 'operate',
            key: 'operate',
            width: 160,
            fixed: 'right',
            render: renderEnhancer((text, record) => {
                const { cashReq, isFirst, status, changeStatus, sortIndex, investigationId, historyNum, contractRemittanceApplicationId,
                    remittanceCompletedInfo, canCopyAdd, canEdit, pmUserList, coPmUserList, deptChargeUserIdList, records, remittanceCode, paymentProgressId, canRequestPayment, paymentProgress } = record;
                if (remittanceCode === '合计') return;
                const isInvSitePM = (pmUserList || []).some(i => i.userId == userId);//是否项目PM
                const isInvCoPM = (coPmUserList || []).some(i => i.userId == userId);//是否项目CO-PM（非主PM）
                const isInvDept = (deptChargeUserIdList || []).some(i => i == userId);//是否项目负责人
                const editableByBA = canEdit;
                const editableByBA_BAL = canEdit;
                const contractNotConfirmed = remittanceCompletedInfo !== 'FIN_Confirmed';
                const hasStatus = fp.contains(status);
                const hasChangeStatus = fp.contains(changeStatus);
                const edit_delete_initiate = contractNotConfirmed && !hasStatus(['CASH_REQ', 'CONFIRM_REQ'])&& !hasChangeStatus(['APPLIED_ADJUSTMENT','REJECT_REMITTANCE_ADJUSTMENT_APPLY']) && editableByBA_BAL;
                const isRequestFinishFlow = fp.contains(remittanceCompletedInfo)(['Tobe_PM_Confirmed', 'Tobe_FIN_Confirmed', 'FIN_Confirmed'])
                const showMilestoneDate = (records || []).length === 0 && isInvSitePM;
                const showMatchReturned = (records || []).length === 0 && (paymentProgressId == 10 || paymentProgressId == 11);

                const operationCorrespondRoles = new Map([
                    ['edit', {
                        name: '修改',
                        display: canEdit && edit_delete_initiate,
                        editable: true,
                        event: () => this.props.update(record, 'edit'),
                        roles: ['*'],
                    }],
                    ['delete', {
                        name: '删除',
                        display: canEdit && edit_delete_initiate,
                        editable: true,
                        event: () => this.props.delete(record),
                        roles: ['*'],
                    }],
                    ['informRequest', {
                        name: '通知请款',
                        display: (isInvSitePM || isInvCoPM || isInvDept) && hasStatus(['NEW_CASH_REQ']),
                        editable: true,
                        event: () => checkProjectIsFinish(investigationId, () => this.props.informRequest(record)),
                        roles: ['*'],
                    }],
                    ['recallInformRequest', {
                        name: '撤回通知请款',
                        display: (isInvSitePM || isInvCoPM || isInvDept) && hasStatus(['NOTICE_CASH_REQ']),
                        editable: true,
                        event: () => this.props.recallInformRequest(record),
                        roles: ['*'],
                    }],
                    ['initiate', {
                        name: '发起请款',
                        display: canRequestPayment && contractNotConfirmed && !hasStatus(['CASH_REQ', 'CONFIRM_REQ']) && !hasChangeStatus(['APPLIED_ADJUSTMENT', 'REJECT_REMITTANCE_ADJUSTMENT_APPLY', 'REMITTANCE_CUSTOMER_APPLY']) && editableByBA_BAL,
                        editable: true,
                        event: () => checkProjectIsFinish(investigationId, () => this.props.update(record, 'initiate')),
                        roles: ['*'],
                    }],
                    ['updateRequest', {
                        name: '更新请款进度',
                        display: canEdit && editableByBA_BAL,
                        editable: !(paymentProgress == '已开票已回款' || paymentProgress == '已开票未回款'),
                        event: () => this.props.update(record, 'update'),
                        roles: ['*'],
                    }],
                    ['updateReturned', {
                        name: '更新回款进度',
                        display: editableByBA_BAL && paymentProgressId != 11,
                        editable: true,
                        event: () => this.props.updateReturned(record),
                        roles: ['CSA', 'CSAL'],
                    }],
                    ['adjust', {
                        name: '申请调整客户付款单位',
                        display: canEdit && canCopyAdd && (hasStatus(['NEW_CASH_REQ', 'NOTICE_CASH_REQ']) && (hasChangeStatus([ 'AGREE_REMITTANCE_ADJUSTMENT_APPLY', 'REJECT_REMITTANCE_CUSTOMER_APPLY', 'AGREE_REMITTANCE_CUSTOMER_APPLY']) || !changeStatus)),
                        editable: true,
                        event: () => this.props.adjustPayUnit(record, 'apply'),
                        roles: ['*'],
                    }],
                    ['copy', {
                        name: '复制新建',
                        display: canEdit && canCopyAdd,
                        editable: true,
                        event: () => this.props.update(record, 'copy'),
                        roles: ['*'],
                    }],
                    ['apply', {
                        name: '申请调整',
                        display: canEdit && (hasStatus(['CASH_REQ']) && (hasChangeStatus([ 'REJECT_REMITTANCE_ADJUSTMENT_APPLY', 'AGREE_REMITTANCE_ADJUSTMENT_APPLY', 'REMITTANCE_CUSTOMER_APPLY', 'REJECT_REMITTANCE_CUSTOMER_APPLY', 'AGREE_REMITTANCE_CUSTOMER_APPLY']) || !changeStatus)) && editableByBA_BAL,
                        editable: true,
                        event: () => this.props.applyAdjustment(record, 'apply'),
                        roles: ['*'],
                    }],
                    ['approve', {
                        name: '审批调整申请',
                        display: canEdit && hasChangeStatus(['APPLIED_ADJUSTMENT']) && approveAdjust,
                        editable: true,
                        event: () => this.props.applyAdjustment(record, 'approve'),
                        roles: ['*'],
                    }],
                    ['approveAdjust', {
                        name: '审批客户付款单位调整申请',
                        display: canEdit && hasChangeStatus(['REMITTANCE_CUSTOMER_APPLY']) && approvePayUnit,
                        editable: true,
                        event: () => this.props.adjustPayUnit(record, 'approve'),
                        roles: ['*'],
                    }],
                    ['applyHistory', {
                        name: '请款历史',
                        display: historyNum >= 2,
                        editable: true,
                        event: () => this.props.applyHistory(contractRemittanceApplicationId),
                        roles: ['*'],
                    }],
                    // ['setStick', {
                    //     name: `${sortIndex ? '取消' : ''}置顶`,
                    //     display: canEdit && editableByBA_BAL,
                    //     editable: true,
                    //     event: () => this.props.handleStick(record),
                    //     roles: ['BA', 'BAL'],
                    // }],
                    // ['milestoneDate', {
                    //     name: '登记milestone到达日期',
                    //     display: showMilestoneDate,
                    //     editable: true,
                    //     event: () => checkProjectIsFinish(investigationId, this.props.registerMilestoneDate(record)),
                    //     roles: ['*'],
                    // }],
                    ['requestDate', {
                        name: '登记确认可请款日期',
                        display: editableByBA_BAL && !cashReq,
                        editable: true,
                        event: () => checkProjectIsFinish(investigationId, this.props.registerRequestDate(record)),
                        roles: ['CSA', 'CSAL'],
                    }],
                    ['matchReturned', {
                        name: '匹配回款',
                        display: editableByBA_BAL && showMatchReturned,
                        editable: true,
                        event: () => checkProjectIsFinish(investigationId, this.props.matchReturned(record)),
                        roles: ['CSA', 'CSAL'],
                    }],
                    ['uploadAttachment', {
                        name: '上传附件',
                        display: canEdit && !isRequestFinishFlow && editableByBA_BAL,
                        editable: true,
                        event: () => checkProjectIsFinish(investigationId, this.props.uploadAttachment(record)),
                        roles: ['*'],
                    }],
                    ['operationLog', {
                        name: '操作日志',
                        display: true,
                        editable: true,
                        event: () => this.props.showOperationLog(record),
                        roles: ['*'],
                    }],
                ]);
                return (
                    <span>
                        {   fp.compose(
                                fp.curry(cf.operationAuthByRole)(index => <span key={index} className="ant-divider" />),
                                fp.filter(i => !!i),
                                // 获取角色对应操作
                                fp.curry(cf.authDomList)(operationCorrespondRoles)
                            )(curRole)
                        }
                    </span>
                );
            }),
        });

        const { expanded } = this.state;
        // 计算scroll.x
        this.width = result.reduce((acc, item) => acc + (item.width || 0), 0);
        // scroll.x < 890时，不左右固定
        if (this.width < 890 || expanded) {
            result[0].fixed = false;
            if (result[result.length - 1].key === 'operate') {
                result[result.length - 1].fixed = false;
            }
        }

        this.nestedColumns = result;
    }

    expandedRowRender = (record) => {
        const data = record.childList || [];
        const height = data.length > 1 ? 400 : false;

        return (
            <Table
                bordered
                columns={this.nestedColumns}
                dataSource={this.getDataSource(data)}
                pagination={false}
                className="requestTable"
                scroll={{ x: this.width, y: height }}
                rowClassName={(record, index) => record.sortIndex ? 'stick_bg' : ''}
            />
        );
    }

    getDataSource = (data) => {
        const dataSource = [];
        (data || []).forEach(d => {
            const { records, manualRecords, investigationId } = d;
            const list = (manualRecords || []).length === 0 ? records : manualRecords;
            const len = (list || []).length;
            if (len) {
                list.forEach((item, index) => {
                    dataSource.push({
                        ...d,
                        ...item,
                        investigationId,
                        rowSpan: index === 0 ? len : 0,
                        rowId: `${d.contractRemittanceApplicationId}-${item.contractBackRecordId}`
                    })
                });
            } else {
                dataSource.push({
                    ...d,
                    rowSpan: 1,
                    rowId: d.contractRemittanceApplicationId
                });
            }
        });
        return dataSource;
    }

    render() {
        const { data } = this.props;
        const { expanded, loading } = this.state;
        const dataSource = (!data || isEmptyObject(data)) ? [] : [data];
        this.getNestedColumns();
        return (
            <Table
                loading={loading}
                scroll={{ x: !expanded ? 950 : this.width + 80 }}
                columns={this.getColumns()}
                dataSource={dataSource}
                rowKey="investigationJdeContractId"
                expandedRowRender={this.expandedRowRender}
                pagination={false}
            />
        );
    }
}

export default ContractTable;


// WEBPACK FOOTER //
// ./src/components/contractManagement/requestRecord/components/ContractTable.js